<template><warehouse-operation-page kind="opening" /></template>
<script>import WarehouseOperationPage from './WarehouseOperationPage.vue'; export default { name: 'WarehouseOpeningOperation', components: { WarehouseOperationPage } }</script>
